import { render } from "./TooltipWrapper.vue?vue&type=template&id=5223be17&scoped=true"
import script from "./TooltipWrapper.vue?vue&type=script&lang=js"
export * from "./TooltipWrapper.vue?vue&type=script&lang=js"

import "./TooltipWrapper.vue?vue&type=style&index=0&id=5223be17&scoped=true&lang=scss"

import exportComponent from "/home/lexmodo/Vue/FraudLabs/fraudlabs_vue/fraudlabs_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5223be17"]])

export default __exports__